import { render, staticRenderFns } from "./CreateCookie.vue?vue&type=template&id=54bee4d6&"
import script from "./CreateCookie.vue?vue&type=script&lang=js&"
export * from "./CreateCookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports